/* CSS */
import styles from './Toast.module.css';

/* Icons */
import toast_success from '../../assets/icons/toast_success.png';
import toast_error from '../../assets/icons/toast_error.png';
import toast_info from '../../assets/icons/toast_info.png';

const Toast = ({ message, type = 'success', _duration = 3000, onClose }) => {
    if (!message) return null;

    return (
        <div className={`${styles.toast} ${styles[type]}`}>
            {/* Grey progress bar: grows left → right over `duration`, full width as the toast closes
            <div className={styles.toastProgress} style={{ animationDuration: `${duration}ms` }} /> */}

            <img src={type === 'success' ? toast_success : type === 'info' ? toast_info : toast_error} alt={type} className={styles.toastIcon} />
            <span className={styles.toastMessage}>{message}</span>
            <button className={styles.toastClose} onClick={onClose}>×</button>
        </div>
    );
};

export default Toast;